var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header-center ms-3 d-none d-lg-block"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"myInput","placeholder":"Rechercher ...","title":"Type in a name"},on:{"keyup":function($event){return _vm.runSearch()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }